import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  padding: 0 30px;
  background: #fff;
  position: relative;

  .file-area {
    height: 340px;
  }

  .layer {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 95%;
    margin: 0 auto 14px auto;
    .layer-body {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      margin-right: 14px;
      padding-top: 2px;
      p,
      span {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 16px;
        color: #5e5e5e;
        margin: 0;
        &.error {
          color: #f32121;
        }
        &.warning {
          color: #ff9800;
        }
      }
      .title {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 6px);
        p {
          overflow-wrap: anywhere;
          /* max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap; */
        }
        span {
          font-style: italic;
        }
      }
      .stat-icon {
        color: #3c71dd;
        &.error {
          color: #c24938;
        }
      }
      .fake-progress {
        margin: 4px 0;
        height: 3px;
        width: 100%;
        .MuiLinearProgress-bar {
          background: #3c71dd;
        }
        &.error {
          .MuiLinearProgress-bar {
            background: #c24938;
          }
        }
      }
    }
    .remove-button {
      border: none;
      padding: 0;
      background: transparent;
      color: #aeaeae;
    }
  }
  
  .container-configure-label {
    overflow: hidden;
    
    .select-symbology {
      float: left;
      width: 50%;
      padding-right: 48px;
    }
  };

  footer {
    position: absolute;
    bottom: 0;
    width: calc(100% - 60px);
    .button-area {
      width: 200px;
      padding: 10px;
      margin: 0 auto;
    }
  }
`;

// TODO Criar estilos de Botão padrão para todo o sistema utilizando styledcomponents, conversar com equipe de design para padronizar padding, etc
// Copiado da tab de catalogo
/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  width: 100%;

  &.MuiButton-root {
    text-transform: none;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 16px;
  }

  &.MuiButton-contained {
    color: #fff;
    background: #3c71dd;

    &:hover {
      background: #3463c1;
    }
  }

  &:disabled {
    background: #aeaeae;
  }
`;
